import { ref } from "vue";
import { defineStore } from "pinia";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
import type { LuresSentVsClicked } from "@/modules/Dashboard/store/types";

export const useLuresStore = defineStore("lures", () => {
  const luresSentVsClicked = ref<LuresSentVsClicked[]>([]);

  const getLuresSentVsClicked = async ({
    globalOrganisationID,
  }: {
    globalOrganisationID: string | null;
  }): Promise<void> => {
    if (globalOrganisationID === null) {
      throw new Error("Organisation ID is not provided");
    }

    const res = await $http.get(
      `${getApiClientUrl()}/v1/cams/manager/${globalOrganisationID}/stats/lures`,
    );

    luresSentVsClicked.value = res.data;
  };

  return {
    luresSentVsClicked,
    getLuresSentVsClicked,
  };
});
